"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Skeleton = _interopRequireDefault(require("./Skeleton"));
var _default = exports["default"] = _Skeleton["default"];